import { lazy } from 'react';

// Lazy load page components for better code splitting
export const HomePage = lazy(() => import('../pages/HomePage'));
export const QuestionsPage = lazy(() => import('../pages/QuestionsPage'));
export const MatchTherapistHome = lazy(
  () => import('@/pages/MatchTherapistHomepage'),
);
// The standalone /match-therapist-v2 flow has its own landing (it will be
// styled differently) but reuses the shared QuestionsPage.
export const MatchATherapistHome = lazy(
  () => import('@/pages/MatchATherapistHomepage'),
);
export const ErrorBoundary = lazy(
  () => import('../components/ErrorBoundary/ErrorBoundary'),
);
export const ErrorBoundaryRoutes = lazy(
  () => import('../components/ErrorBoundary/ErrorBoundaryRoutes'),
);

export const BaseUseCaseHandler = lazy(() => import('./BaseUseCaseHandler'));

export const BaseBotHandler = lazy(() => import('./BaseBotHandler'));
